import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import noop from 'lodash/noop';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
// Core components
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import Button from 'yoda-core-components/lib/components/Button';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import { getPathFromUrl } from 'yoda-core-components/lib/helpers/Utils/Utils';
// Site components
import Pricing from 'yoda-site-components/lib/components/Pricing/Pricing';
import PricingHelper from 'yoda-site-components/lib/components/Pricing/PricingHelper';
import time from 'yoda-core-components/lib/moment/Time';
// Account components
import FinalPriceAfterCoupon from 'yoda-account-components/lib/components/FinalPriceAfterCoupon/FinalPriceAfterCoupon';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Warning from 'yoda-core-components/lib/assets/svg/Warning.svg';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import ReviewAndRating from '../ReviewAndRating/ReviewAndRating';
import HighPriority from '../HighPriority/HighPriority';
import AddToCart from '../AddToCart/AddToCart';
import Move from '../Move/Move';
import * as styles from './ItemTile.css';
import { listRatingSize } from './ItemTile.config';
import { getSavedItems } from '../../../common/getSavedItems';

const cx = classNames.bind(styles);

class ItemTile extends Component {
    static defaultProps = {
        data: {},
        catList: {},
        deviceType: {},
        updateItem: {},
        totalItems: 0,
        isTrendingList: false,
        pageEvent: noop,
        myAlertsProps: {},
    };

    static propTypes = {
        actions: PropTypes.objectOf.isRequired,
        addToCart: PropTypes.objectOf(PropTypes.object).isRequired,
        addToCartActions: PropTypes.objectOf(PropTypes.object).isRequired,
        addToListSuccess: PropTypes.func.isRequired,
        catList: PropTypes.object,
        createList: PropTypes.func.isRequired,
        data: PropTypes.object,
        deviceType: PropTypes.object,
        draftOrder: PropTypes.objectOf(PropTypes.object).isRequired,
        featureFlags: PropTypes.objectOf(PropTypes.object).isRequired,
        isLoggedIn: PropTypes.bool.isRequired,
        isOOSAlert: PropTypes.bool.isRequired,
        isTrendingList: PropTypes.bool,
        LoaderAction: PropTypes.objectOf(PropTypes.object).isRequired,
        location: PropTypes.objectOf.isRequired,
        messagesTexts: PropTypes.objectOf.isRequired,
        MiniPDPActions: PropTypes.objectOf(PropTypes.object).isRequired,
        moveToListSuccess: PropTypes.func.isRequired,
        openSlider: PropTypes.func.isRequired,
        pageEvent: PropTypes.func,
        savedActions: PropTypes.objectOf(PropTypes.object).isRequired,
        showTopLevelMessage: PropTypes.func.isRequired,
        showTopMessage: PropTypes.func.isRequired,
        totalItems: PropTypes.number,
        updateItem: PropTypes.func,
        myAlertsProps: PropTypes.object,
        closeMessageBox: PropTypes.func,
        index: PropTypes.number,
    };

    constructor(props) {
        super(props);
        this.state = {
            mostWantedLoading: false,
            showRemoveItemModal: false,
            showMoveModal: false,
            showAddToListModal: false,
        };
        this.editItem = this.editItem.bind(this);
        this.addItemToCart = this.addItemToCart.bind(this);
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const mostWantedNew = get(nextProps, 'data.mostWanted', false);
        const mostWanted = get(this.props, 'data.mostWanted', false);
        if (mostWanted !== mostWantedNew) {
            this.setState({ mostWantedLoading: false });
        }
        /* istanbul ignore next */
        if (nextProps.draftOrder && nextProps.draftOrder.bag) {
            // let { analyticsData } = this.state;
            const { data } = this.props;
            const {
                product: { id: ppId, name },
                itemId,
                pricing,
            } = data;
            const isAnalyticTriggered = LocalStorage.getData('AddToCartAnalytics');
            if (isAnalyticTriggered && nextProps.draftOrder.bag.items[0].product.id === ppId) {
                const pricingDetails = PricingHelper(pricing);
                const lotId = get(data, 'itemId', '').slice(0, 7);
                const selectedItem = nextProps.draftOrder.bag.items[0];
                const productBundleFlag = selectedItem.product.bundleDiscountApplied ? 'yes' : 'no';
                const analyticsData = {
                    product: [
                        {
                            productInfo: {
                                productPPID: ppId,
                                productLotId: [lotId],
                                productSKU: itemId,
                                productName: name,
                                productDeliveryMethod: 'Ship to Home',
                                productInStock: 'available',
                                productCouponAmount: '0.00',
                                productQuantity: 1,
                                productQuantityDiscount: '0.00',
                                productStoreAvailability: 'available',
                                productSurchargePrice: get(selectedItem, 'charges[0].amount', ''),
                                productEstimatedDelivery: get(
                                    selectedItem,
                                    'deliveryOptions[0].deliveryPromiseMessage',
                                    ''
                                ),
                                productBundleFlag,
                                productMaxQuantityReached: 'no',
                                clickPosition: 'add to bag|my list|main',
                            },
                        },
                    ],
                };

                if (pricingDetails) {
                    const currentOriginalSellingPrice = get(pricingDetails, 'original', '');
                    const currentDefaultSellingPrice = get(
                        pricingDetails,
                        'defaults',
                        currentOriginalSellingPrice
                    );
                    analyticsData.product[0].productInfo.productCurrentSellingPrice = currentDefaultSellingPrice;
                    analyticsData.product[0].productInfo.productCurrentSellingPrice = analyticsData.product[0].productInfo.productCurrentSellingPrice.replace(
                        '$',
                        ''
                    );
                    analyticsData.product[0].productInfo.productListPrice = get(
                        pricingDetails,
                        'defaults',
                        ''
                    );
                    analyticsData.product[0].productInfo.productListPrice = analyticsData.product[0].productInfo.productListPrice.replace(
                        '$',
                        ''
                    );
                    analyticsData.product[0].productInfo.productPricingCadence = get(
                        pricingDetails,
                        'type',
                        ''
                    );
                }
                this.props.savedActions.addCartEvent(analyticsData);
                LocalStorage.removeData('AddToCartAnalytics');
            }
        }
    }

    displayPricing = () => {
        const { data } = this.props;
        const { pricing } = data;
        const couponInfo = get(pricing, 'couponInfo', []);
        if (couponInfo && couponInfo.length > 0) {
            return (
                <div className={cx('couponContainer')}>
                    <FinalPriceAfterCoupon
                        couponPriceDetails={couponInfo}
                        pricingDetails={pricing}
                    />
                </div>
            );
        }
        return (
            <Pricing
                dynamicFont="cartridge"
                pricingDetails={PricingHelper(pricing)}
                priceWrapperClass={dt([
                    'whitespace-normal',
                    'tracking-[0.3px]',
                    'text-xLg',
                    'smMd:mt-0',
                    'smOnly:leading-6',
                ])}
                priceClass={dt(['text-base'])}
                customMarketingLabel={cx('labelClass')}
            />
        );
    };

    displayReviewRating = () => {
        const {
            data: { reviews },
        } = this.props;
        if (reviews && reviews.rating > 0) {
            return (
                <span className={cx('ratingContainer')}>
                    <ReviewAndRating
                        rating={reviews.rating}
                        reviewCount={reviews.reviewCount}
                        cardTheme={listRatingSize.LIST}
                    />
                </span>
            );
        }
        return null;
    };

    updateItemAddToCart = (payload) =>
        new Promise((resolve) => {
            const SKUList = get(this.props, 'data.attributes', []);
            const zipCode = find(SKUList, (sku) => sku.type === 'zipCode');
            const analyticsData = {};
            const from = 'listing';
            const quantity = get(payload, 'quantity', 1);
            const productDetails = {
                data: [
                    {
                        skuId: payload.skuId,
                        ppId: payload.ppId,
                        quantity,
                        deliveryOption: {
                            type: 'HOME',
                            selected: true,
                            zipcode: zipCode && zipCode.value,
                        },
                    },
                ],
            };
            this.props.addToCartActions.addItemToCart(productDetails, analyticsData, from);
            LocalStorage.setData('AddToCartAnalytics', true);
            resolve('Updated Items'); // Not Handled Negative Scenario 1. Failure of API call
        });

    editItem = () => {
        const { data, catList, updateItem, MiniPDPActions } = this.props;
        const {
            id,
            product: { id: ppId },
            itemId,
            ppUrl: url,
        } = data;
        const quantity = get(this.props, 'data.quantity', 1);
        const payload = {
            ppId,
            itemUUId: id,
            updateItem,
            quantity,
            skuId: itemId,
            listId: catList.listId,
            listName: catList.listName,
            url: getPathFromUrl(url),
        };
        MiniPDPActions.selectProduct(payload);
    };

    addItemToCart = () => {
        const { data, catList, MiniPDPActions } = this.props;
        const {
            id,
            product: { id: ppId },
            itemId,
            ppUrl: url,
        } = data;
        const quantity = get(this.props, 'data.quantity', 1);
        const payload = {
            ppId,
            itemUUId: id,
            quantity,
            skuId: itemId,
            listId: catList.listId,
            listName: catList.listName,
            url: getPathFromUrl(url),
        };
        MiniPDPActions.selectProduct(payload);
    };

    displayAttributes = (isSharedView = false) => {
        const {
            data: { attributes, enableMiniPDP, status, quantity },
            isLoggedIn,
        } = this.props;
        const skuView = [];
        if (!isEmpty(attributes)) {
            for (let idx = 0; idx < attributes.length; idx += 1) {
                skuView.push(
                    <span className={dt(['text-gray-70'])}> {attributes[idx].value} | </span>
                );
            }
            quantity && skuView.push(<span className={dt(['text-gray-70'])}>Qty: {quantity}</span>);

            !(!enableMiniPDP && status === 'SELECT_SKU_OPTIONS') &&
                !isSharedView &&
                isLoggedIn &&
                skuView.push(
                    <span className={dt(['text-gray-70'])}>
                        {' '}
                        |{' '}
                        <Button
                            buttonType="Link"
                            size="Sm"
                            className={dt(['text-gray-70', 'mdOnly:ml-0'])}
                            onClick={this.editItem}
                            automationId="edit-the-list"
                        >
                            Edit Options
                        </Button>
                    </span>
                );
            return skuView;
        }
        return skuView;
    };

    mostWantedToggleCallback = (isChecked, listId) => {
        const {
            data,
            actions: { toggleMostWantedInList },
        } = this.props;
        const { mostWantedLoading } = this.state;
        if (!mostWantedLoading) {
            this.setState({ mostWantedLoading: true });
            toggleMostWantedInList(listId, data.id, isChecked);
        }
    };

    toggleMostWantedStatus = (isChecked) => {
        const uuid = this.props.data.id;
        this.props.actions.updateMostWanted(uuid, isChecked);
    };

    openMove = () => {
        const { showMoveModal } = this.state;
        const { isLoggedIn, actions } = this.props;
        actions.clearListError();
        if (isLoggedIn) {
            this.setState({ showMoveModal: !showMoveModal });
        } else {
            this.props.openSlider();
        }
    };

    openAddToList = () => {
        const { showAddToListModal } = this.state;
        const { actions } = this.props;
        actions.clearListError();
        this.setState({ showAddToListModal: !showAddToListModal });
    };

    removeItem = () => {
        const { showRemoveItemModal } = this.state;
        this.setState({ showRemoveItemModal: !showRemoveItemModal });
    };

    confirmRemoveItem = () => {
        const {
            isLoggedIn,
            actions,
            catList,
            data,
            totalItems,
            index,
            closeMessageBox,
        } = this.props;
        const { listId } = catList;
        const {
            product: { id: ppId },
        } = data;
        closeMessageBox();
        if (isLoggedIn) {
            actions.deleteList(listId, data.id, ppId, false, { ...data, removedIndex: index });
        } else if (totalItems > 1) {
            actions.deleteSavedListItem(ppId, data.itemId);
            actions.storeLastRemovedItem({ ...data, removedIndex: index });
        } else {
            const itemIdRemoved = data?.itemId || '';
            getSavedItems('0', ppId, itemIdRemoved, listId);
            actions.getSavedListsGuest();
            actions.storeLastRemovedItem({ ...data, removedIndex: index });
        }
        this.setState({ showRemoveItemModal: false });
    };

    removeItemModalBox = () => {
        const { showRemoveItemModal } = this.state;

        return showRemoveItemModal ? (
            <ModalBox
                onClose={this.removeItem}
                showModal={showRemoveItemModal}
                modalOverlayTheme={cx('slidePanelModalOVerlayWrapper')}
                modalTheme={cx('slidePanelModalWrapper')}
                modalHeaderTheme={dt(['items-center'])}
                modalTitleTheme={dt(['text-left', 'sm:text-xlarge', 'lg:text-2xlarge'])}
                modalContentTheme={dt(['mt-6'])}
                defaultHeader
                title="Remove Item"
            >
                <div className={dt(['mb-6', 'text-medium'])}>
                    Are you sure you want to remove this item from your list?
                </div>
                <div className={dt(['lg:flex', 'lg:flex-row-reverse'])}>
                    <Button
                        automationId="remove-from-the-list"
                        size="Md"
                        className={dt(['smMd:w-full', 'lg:w-[300px]', 'lg:ml-9'])}
                        onClick={this.confirmRemoveItem}
                    >
                        Remove Item
                    </Button>
                    <Button
                        buttonType="Text"
                        size="Md"
                        automationId="cancel-the-list"
                        className={dt([
                            'w-auto',
                            'smMd:mt-4',
                            'smMd:mx-auto',
                            'smMd:!min-h-[auto]',
                            'smMd:!p-0',
                        ])}
                        onClick={this.removeItem}
                    >
                        Cancel
                    </Button>
                </div>
            </ModalBox>
        ) : null;
    };

    displayBadge = () => {
        const { data } = this.props;
        const inventory = get(data, 'inventory', {});
        let badge = get(data, 'badge', {});

        if (!isEmpty(inventory)) {
            if (inventory.atp && inventory.quality && inventory.quality === 'low') {
                badge = {
                    theme: '',
                    text: 'Few Left',
                };
            }

            if (get(inventory, 'message') && inventory.message === 'Out Of Stock Online') {
                badge = {
                    theme: '',
                    text: 'This Item is Out of Stock',
                };
            }
        }
        /**
         * Checking what to show in Badge
         */

        if (!isEmpty(badge)) {
            return (
                <div
                    className={`${cx('badge', badge.theme)} ${dt([
                        'text-small',
                        'text-urgency-border',
                        'mb-2',
                        'smOnly:mb-3',
                        'flex',
                        'gap-1',
                    ])}`}
                >
                    <Icon
                        pathClassName={cx('lockIconSv')}
                        className={cx('lockIconSvg')}
                        iconType="svg"
                        width="20px"
                        height="20px"
                        viewBox="0 0 32 32"
                    >
                        <Warning />
                    </Icon>{' '}
                    {badge.text}
                </div>
            );
        }
        return '';
    };

    pdpNavigation = (PDPURL) => {
        const url = PDPURL.split('.com');
        url[1] ? window.location.assign(url[1]) : window.location.assign(url[0]);
    };

    render() {
        const {
            data,
            location,
            featureFlags,
            addToCart,
            catList,
            LoaderAction,
            isLoggedIn,
            isTrendingList,
            pageEvent,
            addToCartActions,
            moveToListSuccess,
            showTopLevelMessage,
            createList,
            addToListSuccess,
            isOOSAlert,
            messagesTexts,
            myAlertsProps,
            showTopMessage,
        } = this.props;
        const { id: ppId, name: productName, type } = data.product;
        const url = get(data, 'product.image.url', '');
        const {
            enableMiniPDP,
            ppUrl,
            id: uuid,
            itemId,
            dateAdded,
            status,
            vdataType,
            mostWanted = false,
            quantity,
        } = data;
        const search = get(location, 'search', '');
        const query = makeQuery(search);
        const { mostWantedLoading, showMoveModal, showAddToListModal } = this.state;
        const isSharedView = get(query, 'token', false);
        const accountId = get(query, 'accountId', '');
        const { listId, listName } = catList;
        const inventory = get(data, 'inventory', {});
        const isOutOfStock = !!(
            get(inventory, 'message') && inventory.message === 'Out Of Stock Online'
        );
        let PDPURL = '';
        let appendUrl = '';
        if (!enableMiniPDP && !isSharedView) {
            appendUrl = `&uuid=${uuid}&listid=${listId}&listname=${listName}`;
        }
        if ('ppUrl' in data) {
            PDPURL = `${ppUrl}${appendUrl}`;
        }
        const SKUList = get(data, 'attributes', []);
        let editItemCB;
        if (isTrendingList || isSharedView) {
            editItemCB = this.addItemToCart;
        } else {
            editItemCB = isLoggedIn ? this.editItem : this.addItemToCart;
        }
        const addToCartProps = {
            listId,
            uuid,
            itemId,
            enableMiniPDP,
            PDPURL,
            pageEvent,
            LoaderAction,
            addToCart,
            addToCartActions,
            featureFlags,
            ppId,
            status,
            SKUList,
            type,
            vdata: vdataType,
            editItem: editItemCB,
            quantity,
            isOOSAlert,
            messagesTexts,
            buttonTheme: dt(['sm:!text-black sm:!w-full']),
            showTopMessage,
            myAlertsProps,
            isOutOfStock,
        };
        const mostWantedLabel = 'High Priority';
        const isGuestMode = !isLoggedIn;
        const { isTablet, isDesktop, isMobile } = this.props.deviceType;
        const titleProps = {
            onClick: () => {
                this.pdpNavigation(PDPURL);
            },
        };
        const authStatus = isLoggedIn ? 1 : 0;
        const highPriorityComp = (
            <HighPriority
                mostWanted={mostWanted}
                status={status}
                listId={listId}
                toggleCallback={this.mostWantedToggleCallback}
                guestCallback={this.toggleMostWantedStatus}
                productId={data.id}
                label={mostWantedLabel}
                asyncLoading={mostWantedLoading}
                isGuestMode={isGuestMode && !isSharedView}
                isSharedMode={isSharedView}
                authStatus={authStatus}
            />
        );
        const isSelectOption = status === 'SELECT_SKU_OPTIONS' && isTablet;
        return (
            <div
                className={dt([
                    'w-full',
                    'border-b',
                    'border-solid',
                    'border-gray-15',
                    'py-6',
                    'first:pt-0',
                    'table',
                    'last:border-none',
                ])}
                data-automation-id="itemTile"
                id={uuid}
            >
                {this.removeItemModalBox()}
                <div
                    className={dt([
                        'table-cell',
                        'w-[calc(100%-200px)]',
                        'smOnly:w-full',
                        'smOnly:table-row',
                        'relative',
                    ])}
                >
                    <div
                        className={dt([
                            'inline-block',
                            'align-top',
                            'mr-4',
                            'smOnly:mb-4',
                            'smOnly:!mr-0',
                            'w-[168px]',
                            'smMd:w-auto',
                            'smOnly:inline-flex',
                            'smOnly:gap-4',
                        ])}
                    >
                        <div
                            onClick={() => {
                                this.pdpNavigation(PDPURL);
                            }}
                            data-automation-id="pdpUrlClick"
                        >
                            <img
                                className={dt([
                                    'max-w-[168px]',
                                    'max-h-[168px]',
                                    'smOnly:max-w-[104px]',
                                    'smOnly:max-w-[104px]',
                                ])}
                                src={url}
                                alt=""
                            />
                        </div>
                        <div
                            className={dt([
                                'first:-mt-[5px]',
                                'first:pt-0',
                                'first:smOnly:-mt-0.5',
                                'md:hidden',
                            ])}
                        >
                            {this.displayBadge()}
                            {this.displayPricing()}
                        </div>
                    </div>
                    <div
                        className={`${cx('contentBlock')} ${dt([
                            'inline-block',
                            'align-top',
                            'mr-4',
                            'smOnly:!mr-0',
                            'w-[calc(100%-200px)]',
                            'relative',
                            'lg:min-h-[175px]',
                            'mdOnly:lg:min-h-[175px]',
                            'smOnly:w-full',
                            'smOnly:h-full',
                        ])}`}
                    >
                        <div className={dt(['smOnly:hidden'])}>{this.displayBadge()}</div>
                        <div
                            className={dt([
                                'first:-mt-[5px]',
                                'first:pt-0',
                                'first:smOnly:-mt-0.5',
                                'mb-2',
                                'smOnly:hidden',
                            ])}
                        >
                            {this.displayPricing()}
                        </div>
                        <h6
                            className={dt([
                                'text-base',
                                'font-open-sans',
                                'font-semibold',
                                'cursor-pointer',
                            ])}
                            data-automation-id="product-title"
                        >
                            {/* eslint-disable react/jsx-props-no-spreading */}
                            <a
                                className={dt(['text-small'])}
                                {...titleProps}
                                data-automation-id="pdpUrlClickTitle"
                            >
                                {productName}
                            </a>
                        </h6>
                        {this.props.data.reviews && this.props.data.reviews.rating > 0 && (
                            <div className={dt(['cursor-pointer'])}>
                                {/* eslint-disable react/jsx-props-no-spreading */}
                                <a
                                    className={dt(['text-small'])}
                                    {...titleProps}
                                    data-automation-id="pdpUrlClickTitle"
                                >
                                    {this.displayReviewRating()}
                                </a>
                            </div>
                        )}
                        {!isEmpty(SKUList) && (
                            <div className={dt(['mt-2', 'text-small'])}>
                                {this.displayAttributes(isSharedView)}
                            </div>
                        )}
                        {dateAdded && (
                            <div
                                className={dt([
                                    'text-small',
                                    'font-open-sans-regular',
                                    'text-gray-70',
                                    'mt-2',
                                ])}
                            >
                                Added {time(dateAdded).format('MMM DD, YYYY')}
                            </div>
                        )}
                    </div>
                </div>
                <div
                    className={`${cx('btnCheckBoxBlock')} ${dt([
                        'inline-block',
                        'align-top',
                        'mr-4',
                        'smOnly:!mr-0',
                        'w-[168px]',
                        'table-cell',
                        'align-bottom',
                        'w-[200px]',
                        'relative',
                        'text-black',
                        'mdOnly:w-[160px]',
                        'smOnly:w-full',
                    ])}`}
                >
                    <div
                        className={dt([
                            'absolute',
                            'top-0',
                            'right-0',
                            'w-full',
                            'smOnly:relative',
                            'smOnly:mb-6',
                            !isTrendingList && 'smOnly:mt-6',
                        ])}
                    >
                        {highPriorityComp}
                    </div>
                    <div data-automation-id="btnBlock">
                        {/* eslint-disable react/jsx-props-no-spreading */}
                        <AddToCart {...addToCartProps} />
                        {!isSharedView && (
                            <div
                                className={dt(['text-black', 'smMd:inline-block', 'smOnly:w-full'])}
                            >
                                <Button
                                    buttonType="Secondary"
                                    size="Mini"
                                    automationId="move-to-diff-list"
                                    className={`${cx('btnSizeOveride', {
                                        isMobile,
                                        reducePad: isSelectOption,
                                    })} ${dt(['ml-0', 'mr-0', 'inline-flex'])}`}
                                    onClick={this.openMove}
                                >
                                    Move
                                </Button>
                                <Button
                                    buttonType="Secondary"
                                    size="Mini"
                                    className={`${dt([
                                        'ml-0',
                                        'lg:ml-4',
                                        'ml-4',
                                        'mr-0',
                                        'inline-flex',
                                    ])} ${cx('btnSizeOveride')}`}
                                    automationId="remove-from-list"
                                    onClick={this.removeItem}
                                >
                                    Remove
                                </Button>
                                {showMoveModal && (
                                    <Move
                                        showMoveModal={showMoveModal}
                                        closeMoveModal={this.openMove}
                                        listId={listId}
                                        productId={data.id}
                                        createList={createList}
                                        moveToListSuccess={moveToListSuccess}
                                        showTopLevelMessage={showTopLevelMessage}
                                        clickHandler={this.openMove}
                                        isSharedView={isSharedView}
                                        isTrendingList={isTrendingList}
                                        openSlider={this.props.openSlider}
                                        isLoggedIn={isLoggedIn}
                                        title="Move Item"
                                    />
                                )}
                            </div>
                        )}
                        {isSharedView && (
                            <div
                                className={dt([
                                    'mt-4',
                                    'text-black',
                                    'mdOnly:inline-block',
                                    'mdOnly:mt-[5px]',
                                ])}
                            >
                                <Button
                                    buttonType="Secondary"
                                    automationId="add-to-list"
                                    className={dt([
                                        'w-[200px]',
                                        'smOnly:w-full',
                                        '!min-h-[32px]',
                                        '!h-[32px]',
                                    ])}
                                    onClick={this.openAddToList}
                                >
                                    Add to List
                                </Button>
                                <div
                                    className={dt([
                                        'mdOnly:relative',
                                        'mdOnly:right-[unset]',
                                        'mdOnly:-left-[69px]',
                                    ])}
                                >
                                    {showAddToListModal && (
                                        <Move
                                            listId={listId}
                                            ppId={data.product.id}
                                            itemId={itemId}
                                            createList={createList}
                                            moveToListSuccess={moveToListSuccess}
                                            addToListSuccess={addToListSuccess}
                                            showTopLevelMessage={showTopLevelMessage}
                                            showTopMessage={showTopMessage}
                                            clickHandler={this.openAddToList}
                                            addToListFlag
                                            isSharedView={isSharedView}
                                            isTrendingList={isTrendingList}
                                            accountId={accountId}
                                            openSlider={this.props.openSlider}
                                            isLoggedIn={isLoggedIn}
                                            showMoveModal={showAddToListModal}
                                            closeMoveModal={this.openAddToList}
                                            title="Add to List"
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default ItemTile;
